import React from 'react';
import { Link } from 'react-router-dom';

function ThankYou() {
  return (
    <section className="service-request-section">
      <div className="container">
        <div className="thank-you-content">
          <div className="thank-you-icon">✓</div>
          <h2 className="section-title">Service Request Submitted Successfully!</h2>

          <div className="thank-you-message">
            <p>Thank you for submitting your service request to Morning Light Funeral Services.</p>
            <p>We have received your request and will contact you via email or phone call to confirm the details.</p>
            <p className="important-note">
              <strong>Please note:</strong> Your service request is NOT CONFIRMED until you receive notification from us.
            </p>
            <p>If you have any immediate questions or concerns, please contact us:</p>
            <div className="contact-details">
              <p><strong>Phone:</strong> (909) 925-8671</p>
              <p><strong>Email:</strong> JimmyPeo@mlfuneral.com</p>
            </div>
          </div>

          <div className="thank-you-actions">
            <Link to="/" className="btn-primary">Return to Home</Link>
            <Link to="/service-request" className="btn-secondary">Submit Another Request</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ThankYou;
